<template>
    <div style="text-align: start">
        <ion-text class="contact-ways-text">{{ $t('signup.contactWaysTitle') }}</ion-text>
        <ion-list lines="none">
            <checkbox
                v-for="option in options"
                :key="option.id"
                :label="option.value"
                @onChange="handleChange"
                :optionId="option.id"
                :checked="contactWays ? contactWays.find(({ id }) => id === option.id) : false"
            />
        </ion-list>
    </div>
</template>

<script>
import Checkbox from '../components/Checkbox'

export default {
    components: { Checkbox },
    name: 'CheckboxList',
    props: ['options', 'label', 'type', 'contactWays'],
    methods: {
        handleChange: function(data) {
            this.$emit('onChange', {
                data: data,
                type: this.type,
                optionId: this.optionId
            })
        }
    }
}
</script>

<style lang="scss" scoped>
h5 {
    padding-left: 15px;
    font-size: 80%;
    color: #f5f5f5;
    margin-bottom: 2px;
}
.contact-ways-text {
    position: relative;
    left: 15px;
    font-weight: 600;
}

@media (min-width: 768px) {
    ion-list {
        width: 30%;
        margin-top: 10px;
    }

    h5 {
        font-size: 100%;
        margin-bottom: 3px;
    }
}

@media (min-width: 1200px) {
    ion-list {
        --background: transparent;
        padding: 0;
    }
    ion-text {
        font-size: 120% !important;
    }
}
</style>
